import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useUpdateIotAgent } from './useUpdateIotAgent';
import useUpdateIotAgentColumns from './updateIotAgentVersionColumn';
import './updateIotAgentVersion.scss';
import TableView from '../../tableView';
interface IProps {
  show?: boolean;
}

const UpdateIotAgentVersion = (props: IProps) => {
  const { row, handleClose, handleUpdate, onRowSelectionChange, isDisabled } =
    useUpdateIotAgent();

  const { columns } = useUpdateIotAgentColumns({ onRowSelectionChange });


  return (
    <>
      <Modal
        show={props.show}
        onHide={handleClose}
        className='modal-container modal'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update IOT Agent Version</Modal.Title>
        </Modal.Header>

        <Modal.Body className='modal-content-height'>
          <div className='firmware_container'>
            <div className='firmware_body'>
              <div className='table_content'>
                <div className={'manage-firmware-table '}>
                  <TableView
                    singleRowSelection={true}
                    data={row.values}
                    columns={columns}
                    noDataMessage={'No Data'}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className='btn-style'
            onClick={handleUpdate}
            disabled={isDisabled}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateIotAgentVersion;
